// extracted by mini-css-extract-plugin
module.exports = {"smallLabel":"SmallLabel-module--smallLabel--1vOUH"};